import { render, staticRenderFns } from "./order_double_recording.vue?vue&type=template&id=fdd35e50&scoped=true&"
import script from "./order_double_recording.vue?vue&type=script&lang=js&"
export * from "./order_double_recording.vue?vue&type=script&lang=js&"
import style0 from "./order_double_recording.vue?vue&type=style&index=0&id=fdd35e50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd35e50",
  null
  
)

export default component.exports